
/*This file exists to package each of the Subscription Service angular modules into a single angular module for
 * ease of use by the Subscription Data Service.
 *
 */

import angular from "angular";

import TrackingTargetSubscriptionServiceModule from "./TrackingTargetSubscriptionService";
import StateOfficeSubscriptionServiceModule from "./StateOfficeSubscriptionService";
import StateEventSubscriptionServiceModule from "./StateEventSubscriptionService";
import OfficeSubscriptionServiceModule from "./OfficeSubscriptionService";
import OfficeTypeSubscriptionServiceModule from "./OfficeTypeSubscriptionService";
import ElectionSubscriptionServiceModule from "./ElectionSubscriptionService";

export default angular
    .module("trackerbase-app.services.subscription-data-services",[
        TrackingTargetSubscriptionServiceModule,
        StateOfficeSubscriptionServiceModule,
        StateEventSubscriptionServiceModule,
        OfficeSubscriptionServiceModule,
        OfficeTypeSubscriptionServiceModule,
        ElectionSubscriptionServiceModule
    ])
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/subscription-data-services/index.js
// module id = XCT4
// module chunks = 1